/**
 * QL-375 — the one way a mandate percentage is printed: one decimal, a
 * percent sign, an en dash for "no figure". Shared by the web widget, the
 * advice document (Typst) and the AI reader, so the three never drift.
 */
export function formatMandatePct(value: number | null | undefined): string {
  return value == null ? "–" : `${value.toFixed(1)}%`;
}
